module.exports = __webpack_public_path__ + "static/media/newMessage.5a226a4f.png";